import React, { useEffect, useState } from 'react';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../../firebaseConfig';
import { useUser } from '../../context/UserContext';
import Swal from 'sweetalert2';

import UserNav from '../../components/navbar/user-nav';
import FooterTop from '../../components/footer-top';
import Footer from '../../components/footer';

export default function AdminProyectos() {
  const { user } = useUser();
  const navigate = useNavigate();
  const [proyectos, setProyectos] = useState<any[]>([]);
  const [filtro, setFiltro] = useState('');
  const [paginaActual, setPaginaActual] = useState(1);
  const proyectosPorPagina = 5;

  useEffect(() => {
    const fetchProyectos = async () => {
      const snap = await getDocs(collection(db, 'proyectos'));
      const data = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setProyectos(data);
    };
    fetchProyectos();
  }, []);

  // 🔐 Validación de acceso
  if (!user || !user.tipo?.includes('admin')) {
    return (
      <div className="container mt-5">
        <h2>No tienes permiso para acceder a esta sección</h2>
      </div>
    );
  }

  const handleDelete = async (id: string) => {
    const confirm = await Swal.fire({
      title: '¿Eliminar proyecto?',
      text: 'Esto no eliminará las propiedades asociadas, solo el proyecto.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33'
    });

    if (!confirm.isConfirmed) return;

    try {
      await deleteDoc(doc(db, 'proyectos', id));
      setProyectos(prev => prev.filter(p => p.id !== id));

      Swal.fire({
        icon: 'success',
        title: 'Proyecto eliminado',
        text: 'El proyecto ha sido eliminado exitosamente.',
        confirmButtonColor: '#3085d6'
      });
    } catch (error) {
      console.error('Error al eliminar proyecto:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un problema al eliminar el proyecto.',
        confirmButtonColor: '#d33'
      });
    }
  };

  // 🔍 Filtro por nombre
  const proyectosFiltrados = proyectos.filter(p =>
    p.nombre?.toLowerCase().includes(filtro.toLowerCase())
  );

  // 📄 Paginación
  const totalPaginas = Math.ceil(proyectosFiltrados.length / proyectosPorPagina);
  const startIndex = (paginaActual - 1) * proyectosPorPagina;
  const proyectosPaginados = proyectosFiltrados.slice(startIndex, startIndex + proyectosPorPagina);

  return (
    <>
      <UserNav />
      <div className="container mt-5">
        <h1 className="text-center mb-4">Administración de Desarrollos</h1>

        <div className="d-flex justify-content-between mb-3">
          <input
            type="text"
            className="form-control me-3"
            style={{ maxWidth: '300px' }}
            placeholder="Buscar por nombre..."
            value={filtro}
            onChange={(e) => {
              setFiltro(e.target.value);
              setPaginaActual(1);
            }}
          />
          <button className="btn btn-success" onClick={() => navigate('/submit-project')}>
            + Agregar Proyecto
          </button>
        </div>

        {proyectosFiltrados.length === 0 ? (
          <p>No hay proyectos registrados.</p>
        ) : (
          <>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>Nombre</th>
                    <th>ID Inmobiliaria</th>
                    <th>Descripción</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {proyectosPaginados.map(proyecto => (
                    <tr key={proyecto.id}>
                      <td>{proyecto.nombre}</td>
                      <td>{proyecto.inmobiliaria_id}</td>
                      <td>{proyecto.descripcion?.slice(0, 50)}...</td>
                      <td>
                        <button
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => navigate(`/edit-project/${proyecto.id}`)}
                        >
                          ✏️
                        </button>
                        <button
                          className="btn btn-danger btn-sm me-2"
                          onClick={() => handleDelete(proyecto.id)}
                        >
                          🗑️
                        </button>
                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={() => navigate(`/ver-project/${proyecto.id}`)}
                        >
                          Ver Proyecto
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <nav className="d-flex justify-content-center mt-3">
              <ul className="pagination">
                {Array.from({ length: totalPaginas }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${paginaActual === i + 1 ? 'active' : ''}`}
                    onClick={() => setPaginaActual(i + 1)}
                    style={{ cursor: 'pointer' }}
                  >
                    <span className="page-link">{i + 1}</span>
                  </li>
                ))}
              </ul>
            </nav>
          </>
        )}
      </div>
      <FooterTop bg="theme-bg" />
      <Footer />
    </>
  );
}
